var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiScholoptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107284",
    "data-name": "Group 107284",
    transform: "translate(-458 -582)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40441",
    "data-name": "Rectangle 40441",
    width: 32,
    height: 32,
    transform: "translate(458 582)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106167",
    "data-name": "Path 106167",
    d: "M17,2,1,10.727H17v1.455H3.909L1,10.727V22.364H3.909V12.338L17,19.455l16-8.727ZM6.818,16.256v6.4A11.588,11.588,0,0,0,17,28.182a12.452,12.452,0,0,0,4.364-.761V22.364a7.494,7.494,0,0,1,.616-2.989L17,22.364Zm20.364.29V18.29a4.056,4.056,0,0,0-2.909,4.074c0,2.764,2.327,3.637,3.781,4.219,1.745.727,2.037.872,2.037,1.6a1.3,1.3,0,0,1-1.455,1.455,1.3,1.3,0,0,1-1.455-1.455H24.273a4.249,4.249,0,0,0,2.909,4.074V34h2.909V32.256A4.249,4.249,0,0,0,33,28.182c0-2.764-2.327-3.637-3.781-4.219-1.745-.727-2.037-.872-2.037-1.6a1.3,1.3,0,0,1,1.455-1.455,1.3,1.3,0,0,1,1.455,1.455H33a4.249,4.249,0,0,0-2.909-4.074V16.545Z",
    transform: "translate(457 580)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiScholoptions);
export default __webpack_public_path__ + "static/media/visionai_scholoptions.645aa868510aaefe2eedf23aa80291b2.svg";
export { ForwardRef as ReactComponent };